// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  page_size: 15,
  production: false,
  appVersion: 'v100jawaly',
  USERDATA_KEY: 'authf649fc9a5f55',
  sallaToken: 'MDQxZjkzZmQtMTg1Yy00MjNhLTkxZDktZTczMjY2MDBjZDVkOjFkOTA1ODhmLTlhZTMtNGFiMy1iYzM1LTRjNTFhMGJkOGE3YQ==',
  sallaUrl: 'https://salla.4jawaly.com/', // dev
  // apiUrl: 'https://4j-dev.viewclass.com/api/v1',
  apiUrl: 'https://api-4j-dev.4ja.ai/api/v1', // dev
  recaptcha: {
    siteKey: '6LcVoEkjAAAAAFWIZQ6ueyJNpvgL0SXOpSmJcYhF',
  },
  recaptchaV2Key: '6LedXNUSAAAAABuSDjDAgRXWRGWZebTuMIOYnVqV',
  pusher: {
    key: '5334d0b3109b8a2b097f',
    cluster: 'eu',
  },
  sma: {
    apiUrl: 'https://api-sms-dev.4ja.ai/api/v1/'
  },
  salla : {
    whats : 'https://salla.4jawaly.com/whatsapp/'
  },
  whats : {
    url : 'https://w-hub.4jawaly.com/api/v1/admin/'
  },
  commission : {
    api : 'https://commission.4ja.ai/'
  },
  PDF_URL: "https://pdfv1.viewclass.com/web/viewer.html?file=",
  userSiteUrl : "https://user-dev.4ja.ai//guest"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
